import React from 'react';
import { ProductCardWrapper, } from '../ProductCardList/ProductCard/ProductCardWrapper';
export const SelectableWrapper = ({ children, selectedIcon, ...props }) => {
    return (React.createElement(ProductCardWrapper, { cursor: "pointer", height: "100%", ...props },
        selectedIcon,
        children));
};
//# sourceMappingURL=SelectableWrapper.js.map